import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubAdminsComponent } from './sub-admins/sub-admins.component';
import { AddUpdateSubAdminComponent } from './add-update-sub-admin/add-update-sub-admin.component';

const routes: Routes = [
  {
    path: '',
    component: SubAdminsComponent
  },
  {
    path: 'add',
    component: AddUpdateSubAdminComponent,
  },
  {
    path: 'update/:id',
    component: AddUpdateSubAdminComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubAdminRoutingModule { }
